import { availableInternationalization, fallbackInternationalization, Errors, chineseExchangeableLanguages, defaultInternationalization, defaultLanguages } from 'corporate-types';
export const internationalizationToLanguages = (internationalization, from) => {
    var _a, _b;
    if (Object.values(defaultLanguages).indexOf(internationalization) !== -1) {
        internationalization = defaultInternationalization;
    }
    const internationalizationFoundkey = Object.keys(availableInternationalization).find((key) => availableInternationalization[key] === internationalization);
    const internationalizationSplitted = internationalization === null || internationalization === void 0 ? void 0 : internationalization.split('-');
    const internationalizationFoundFallbackKey = internationalizationSplitted.length > 1 ? internationalizationSplitted[0].toLocaleLowerCase() : undefined;
    if (internationalizationFoundkey || internationalizationFoundFallbackKey) {
        const internationalizationFound = (_a = internationalizationFoundkey) !== null && _a !== void 0 ? _a : availableInternationalization[internationalizationFoundkey];
        const internationalizationFallbackFound = (_b = internationalizationFoundFallbackKey) !== null && _b !== void 0 ? _b : availableInternationalization[internationalizationFoundFallbackKey];
        const language = fallbackInternationalization[internationalizationFound];
        const languageFallback = fallbackInternationalization[internationalizationFallbackFound];
        if (language) {
            return language;
        }
        else if (languageFallback) {
            return languageFallback;
        }
        else {
            console.error(Errors.NO_FALLBACK_FOUND, availableInternationalization, internationalization, internationalizationFoundkey, internationalizationFoundFallbackKey, from);
            return undefined;
        }
    }
    else {
        console.error(Errors.NO_INTERNATIONALIZATION_FOUND, availableInternationalization, internationalization, internationalizationFoundkey, internationalizationFoundFallbackKey, from);
        return undefined;
    }
};
export const checkExchangeableLocalization = (locale) => {
    if (chineseExchangeableLanguages.includes(locale))
        return chineseExchangeableLanguages;
    return [locale];
};
//# sourceMappingURL=languages.js.map